import { Preset } from '../../types/types';
import { createControllerFactory } from '../BookingCalendar/controller';
import weeklyTimetableSettingsParams from './settingsParams';

export default createControllerFactory(
  Preset.WEEKLY_TIMETABLE_WIDGET,
  weeklyTimetableSettingsParams,
);
